import React from "react";
import { UnstyledButton, Group, Flex, Avatar, Text } from "@mantine/core";
import { Link } from "react-router-dom";

import { LogoutButton } from "@components/Auth";

export default function Nameplate({
  title = "Name Missing",
  subtitle,
  avatarUrl,
}) {
  const initials = getFirstLetters(title);

  return (
    <Group>
      <UnstyledButton component={Link} to="/profile">
        <Flex gap="xs" align="center">
          <Avatar size={40} radius="100%" color="blue" src={avatarUrl}>
            {avatarUrl === null && `${initials}`}
          </Avatar>
          {/* <div>
            <Text c="gray.2" size="sm" fw={600}>
              {title}
            </Text>
            {subtitle && (
              <Text size="xs" c="dimmed">
                {subtitle}
              </Text>
            )}
          </div> */}
        </Flex>
      </UnstyledButton>
      <LogoutButton />
    </Group>
  );
}

Nameplate.defaultProps = {
  subtitle: "",
  title: "Name",
};

function getFirstLetters(str) {
  if (!str) return "CS";

  const firstLetters = str
    .split(" ")
    .map((word) => word[0])
    .join("");

  return firstLetters;
}
